module.exports = __webpack_public_path__ + "static/NotoKufiArabic-Bold-b7019b2fae855353922e38014e00e88d.woff2";